import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { fetchHeartbeat } from '../store/actions/AssessmentActions';
import { HEARTBEAT_TYPE_OVERALL } from '../const';

const interval = 10000;
const useHeartbeat = (assessment_id, type = HEARTBEAT_TYPE_OVERALL, currentSectionId = null) => {
  const dispatch = useDispatch();
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!intervalRef.current && assessment_id) {
      intervalRef.current = setInterval(() => {
        dispatch(fetchHeartbeat(assessment_id, type, currentSectionId));
      }, interval);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [dispatch, assessment_id, type, currentSectionId, interval]);
};

export default useHeartbeat;
